import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../Context/UserContext";
import { Loader } from "../../UI";

/**
 * ProtectedPublic — garde pour les routes CLIENT uniquement.
 * - Non authentifié → /login (avec sauvegarde redirectAfterLogin)
 * - Authentifié type 'admin' → /admin  (mélange de rôles impossible)
 * - Authentifié 'client' ou 'conducteur' → accès accordé
 */
const ProtectedPublic = ({ children }) => {
  const { isAuthenticated, user, loading } = useUser();
  const location = useLocation();
  const { t } = useTranslation('common');

  if (loading) {
    return <Loader size="large" text={t('ui.checkAuth')} />;
  }

  if (!isAuthenticated) {
    // Sauvegarder la destination (chemins relatifs uniquement — anti open-redirect)
    const safePath = location.pathname + location.search;
    if (safePath.startsWith('/') && !safePath.startsWith('//') && !safePath.includes('://')) {
      sessionStorage.setItem("redirectAfterLogin", safePath);
    }
    return <Navigate to="/login" replace />;
  }

  // Un admin connecté ne doit pas accéder aux routes client
  if (user?.type_utilisateur === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default ProtectedPublic;
